import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton } from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const GiftShopParlor = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/outlet/giftShopOutlet/super_fast_billing.webp",
            tag: "Point Of Sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Super Fast Billing",
            desc: "Streamline your checkout process with QueueBuster’s rapid and versatile billing system, which handles various payment methods. Manage bulk transactions smoothly and create part or split payments with ease. Benefit from:",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Ultra-fast checkout in less than 5 seconds
                </>,
                <>
                    Support for multiple payment batches
                </>,
                <>
                    Ability to generate different invoice types such as proforma, credit, sales, and e-invoices.
                </>,
            ],
        },
        {
            id: 2,
            image: "/assets/outlet/giftShopOutlet/inventoryGiftShopImage.webp",
            title: "Automate Stock Management",
            icon: "/assets/outlet/iceCreamOutlet/inventoryManagementIcon.svg",
            tag: "Inventory Management",
            desc: "Using automated stock management features of QB software, you can easily manage your inventory and ensure that stocks never run out in your gift shop, especially during peak seasons of demand. Get instant alerts for fast-moving items and be better placed to manage in-store and online inventory with ease.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Alerts on fast-selling stock keep you ahead in the festive seasons.
                </>,
                <>
                    Generate barcodes and labels for effective product tracking.
                </>,
                <>
                    Maintain an up-to-date stock catalog list with product images.
                </>
            ],
        },
        {
            id: 3,
            image: "/assets/outlet/giftShopOutlet/crm&loyalty.webp",
            tag: "CRM & Loyalty",
            icon: "/assets/outlet/giftShopOutlet/CRM.svg",
            title: "Customer Centric Loyalty Program",
            desc: "Design a customer loyalty scheme implemented with QB's CRM module, to suit the provisions of your gift shop. The software keeps you close to the customers, automating the records for ongoing membership, reviews, and even reminders on their birthdays.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk	to an expert",
            points: [
                <>
                   Integrate with existing crm tool.
                </>,
                <>
                    Gift cards and bonus points can be provided to the customers
                </>,
                <>
                    Promotion of birthday and anniversary offers in front of customers
                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/outlet/giftShopOutlet/storeGiftShopImage.webp",
            tag: "e-Billing",
            icon: "/assets/outlet/giftShopOutlet/e-waybill.svg",
            title: "Billing on WhatsApp & Email",
            desc: "Make your checkout process much easier with the QB software paperless billing system. Digital invoices can be generated, discounts applied, and fast payment provision at checkout is made easy due to the multiple gateways that give a seamless customer experience.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Share digital invoices seamlessly on WhatsApp itself
                </>,
                <>
                    Error free, GST-compliant billing for error-free transactions
                </>,
                <>
                    Quick and Efficient Checkouts with Modern mPOS.
                </>,
                // <>
                //     Frequently Asked Questions for the Gift Shop Billing Software
                // </>
            ],
        },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QB Gift Shop Billing Software help in managing peak seasonal inventories?
                </span>
            ),
            des: "QB Gift Shop Billing Software consists of an inventory management system that ensures your shop is well-stocked throughout the year, even at peak seasonal times. It provides the facility for automatic stock level tracking and instant alerts in case of fast-moving stocks. This will allow you to know when your popular products are running low on stock and it's time to reorder—ensuring you never miss a sale. Additionally, barcode and labeling generation in the software facilitates easier product tracking and management in both in-store and online sales.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I customize offers and promotions for my customers using QB's CRM features?
                </span>
            ),
            des: "Yes, QB CRM functionalities are designed to ensure the building of close and long-lasting relationships with customers through personalized offers and promotions. One may establish comprehensive customer profiles, where customers will be segmented into their purchasing history, preferences, and more. This will, in turn, have you tailoring personalized promotions—like birthday discounts or loyalty rewards—to make them feel valued and secure repeat business. It also helps in the management of memberships, tracking customers' reviews, and sending automated reminders for special days, including birthdays and anniversaries.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the paperless billing system work in QB Gift Shop Billing Software?
                </span>
            ),
            des: "The paperless billing system in QB Gift Shop Billing Software provides digital invoices that reach the customers directly on their WhatsApp or email, which shortcuts the process of checkout. This diminishes paper wastage, quickens the process of billing, and turns out to be more convenient for both you and your customers. The software ensures error-free and GST-compliant invoices, reducing discrepancies in your financial records. Besides, multiple integrated payment gateways, including UPI, make transactions quicker and safer for a richer customer experience.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How is QB Gift Shop Billing Software going to increase its customer retention?
                </span>
            ),
            des: "The QB's CRM features, which are customer-centric, greatly help in customer retention. You can reward repeat customers with loyalty programs by awarding them points, gift vouchers, or some exclusive discounts. Maintaining a record of their purchase history and preferences will help you in customizing personalized offers that really resonate with your customers. After all, timely reminders about birthdays and anniversaries among your customers by sending special offers do make them feel valued; therefore, they are more likely to come back for repeated shopping with you.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I handle inventory in-store and online with QB Gift Shop Billing Software?
                </span>
            ),
            des: "Yes! QB Gift Shop Billing Software can easily manage both store and online inventories. The software integrates the flow of your inventory information between all sales channels, always giving you a precise picture regarding the availability of your stock. Whether a customer makes a purchase online or in-store, the inventory gets automatically updated. This reduces the risk of overselling or stock discrepancies. Moreover, the software provides automated alerts for low-stock items so you can restock promptly and avoid any breaks in business operations.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How is the software going to manage GST compliance at the billing level?
                </span>
            ),
            des: "QB Gift Shop Billing Software is fully GST-compliant, allowing you to charge GST. It calculates GST for every transaction and generates the invoice accurately with the compliance needed by the law. It also helps in grouping the products in their concerned GST rating rates for easy management and reporting of the taxes. It further records all the transactions made securely, cushioning it for the sole purpose of filing your GST returns and doing audits.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I maintain and monitor many vendors through QB Gift Shop Billing Software?
                </span>
            ),
            des: "Yes, QB Gift Shop Billing Software will provide you with a way to handle multiple vendors without any fuss. Using it, you can maintain detailed records of the transactions with each vendor regarding the purchase date, amount paid, and outstanding balance. Also, you can track receivables and payables for you to know where your cash stands with regard to inflows and outflows. You can set automated payment reminders through email or SMS to ensure that all payments are made on time, keeping your relationships with vendors very healthy.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How can I produce reports using this software and do some analysis of my business performance?
                </span>
            ),
            des: "QB Gift Shop Billing Software is fully equipped to provide you with all types of reporting so that you can analyze business performance in depth. You will be able to generate daily, monthly, or yearly sales reports, track profit/loss, and review inventory levels. You can create these reports in mobile and desktop versions. This will put crucial real-time data in your hands for better decision-making. You will be able to gain from such reports sales trends, customer preference, and tips on inventory and marketing strategies towards more desirable ends.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Does the software cater only to larger businesses, or will it work effectively with small gift shops?
                </span>
            ),
            des: "QB Gift Shop Billing Software does not turn out versatile and viable for a small boutique or even a large gift shop but scales with the business. It can handle billing, inventory, customer engagement, etc., thus freeing the mind of the owner of a small shop so he can really run his business. For larger businesses, it has multi-location management, detailed financial reporting, and CRM tools that help in running more complicated operations.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QB Gift Shop Billing Software handle discounts and promotions during checkout?
                </span>
            ),
            des: "QB Gift Shop Billing Software will quickly make an application to claim already configured discounts and promotions at the stage of checkout. It means; that pre-defined discounts, seasonal promotions, or any special offers related to a customer have been set in the software. While processing sales, the program automatically applies these discounts to the invoice, ensuring exact billing. It also provides a person with the ability to track the effectiveness of the promotions by generating discount usage reports and sales impact reports so one can fine-tune marketing strategies over time.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/outlet/giftShopOutlet/mobileGiftShopImage.webp')" }}>
                        <div>
                            <h1>
                                <span>Gift Shop</span><span></span>
                                <span>&nbsp; Billing Software</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Whether small boutiques or large gift shops, what you want is reliable and effective billing software that can run the show smoothly. With QB gift shop billing software, you will be able to streamline your billing, inventory management, and customer service.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/outlet/giftShopOutlet/giftShopHeroImage.webp"
                            heading={<>Gift Shop </>}
                            staticHeading={<> Billing Software</>}
                            description={"Whether small boutiques or large gift shops, what you want is reliable and effective billing software that can run the show smoothly. With QB gift shop billing software, you will be able to streamline your billing, inventory management, and customer service."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "50%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Best Features of Billing Software for Gift Shop Parlors</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"Frequently Asked Questions for a Gift Shop Billing Software "} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"Frequently Asked Questions for a Gift Shop Billing Software "} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default GiftShopParlor